<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Run Scenario</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="run scenario" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>Scenario Name</label>
                <select v-model="scenarioName">
                    <option value="">Select Scenario</option>
                    <option v-for="scenario in scenarios" :key="scenario" :value="scenario">
                        {{ scenario }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Technology</label>
                <select v-model="technology">
                    <option value="">Select Technology</option>
                    <option v-for="tech in TECHNOLOGIES" :key="tech" :value="tech">
                        {{ tech }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Resource Size</label>
                <select v-model="resourceSize">
                    <option value="">Select Resource Size</option>
                    <option v-for="size in RESOURCE_SIZES" :key="size" :value="size">
                        {{ size }}
                    </option>
                </select>
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createRunScenarioModelWorkflowItem, TECHNOLOGIES, RESOURCE_SIZES } from '../utils/workflowUtils';
import { useScenarioSelection } from '../composables/useScenarioSelection';

// Use composable for scenario selection logic
const { scenarios } = useScenarioSelection();

const actionName = ref('');
const scenarioName = ref('');
const technology = ref('');
const resourceSize = ref('');

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createRunScenarioModelWorkflowItem(
        actionName.value,
        scenarioName.value,
        technology.value,
        resourceSize.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
